import { generateUniqueId } from '../../helpers/common';

export const ADD_LIVE_STATION_RECORD = generateUniqueId();
export const ADD_LIVE_STATION_RECORD_FAILURE = generateUniqueId();
export const SELECT_LIVE_STATION = generateUniqueId();
export const CLEAR_STATION_DATA = generateUniqueId();

export const ADD_HEALTH_STREAMING_RECORD = generateUniqueId();

export const TOGGLE_STATION_LIST_DIALOG = generateUniqueId();

export const SET_SITE_PHOTOS = generateUniqueId();
export const SET_SITE_PHOTOINDEX = generateUniqueId();
export const SET_SITE_PHOTOS_DISPLAY_INTERVAL_ID = generateUniqueId();

export const SET_STATION_TIME_OFFSET = generateUniqueId();

export const GET_TOTALIZE = generateUniqueId();
export const GET_TOTALIZE_FAILED = generateUniqueId();